import React, { ReactNode, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import koopLogo from '../../../assets/koop-draft-logo.png';
import iconUsername from '../../../assets/profile.png';
import iconMenu from '../../../assets/menu.png';

import helperIndex from '../../../helpers/index';

import MessageModal from '../../Modal/MessageModal';
import iconImport from '../../../assets/import-data.png';
import iconLogout from '../../../assets/logout.png';

import iconLock from '../../../assets/lock.png';
import iconLoan from '../../../assets/loans.png';
import iconProfileDetails from '../../../assets/profile-details.png';
import warningIcon from '../../../assets/warning-icon.png';
import helper from '../../../helpers/index';

interface MembersPortalLayoutProps {
    children: ReactNode;
}

const MembersPortalLayout: React.FC<MembersPortalLayoutProps> = ({ children }) => {

    const dispatch = useDispatch();
    const location = useLocation();

    const [logUser, setLogUser] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [modalMessage, setModalMessage] = useState('');
    const [modalMessageOpen, setModalMessageOpen] = useState(false);
    const [activePath, setActivePath] = useState<string>(location.pathname);

    var username = helperIndex.getCookieValue('username');

    function checkTokenExpiration() {

        var intervalMinutes = Number(process.env.REACT_APP_CHECK_TOKEN_INTERVAL) * 60000;

        setInterval(function () {

            var refreshToken: string = helper.getCookieValue('refreshToken');

            if (!refreshToken) {
                setModalMessage("Session has expired. Please login again");
                setModalMessageOpen(true);
            }

        }, intervalMinutes);

    }

    function onClose() {

        setModalMessageOpen(false);
        window.location.href = '/Members/Login';
    }

    useEffect(() => {
        (async () => {

            // document.querySelector('.loader-container')?.classList.add('loader');
            var isNotExpired = await dispatch({ type: 'middleware' });

            if (typeof isNotExpired === 'boolean') {

                if (!isNotExpired) {
                    setModalMessage("Session has expired. Please login again");
                    setModalMessageOpen(true);
                }
            }

            checkTokenExpiration();

            setLogUser(username);

            const savedActivePath = localStorage.getItem('activePath');
            if (savedActivePath) {
                setActivePath(savedActivePath);
            }

            // document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 992) {
                setIsSidebarOpen(false);
            } else {
                setIsSidebarOpen(true);

            }
        };

        window.addEventListener('resize', handleResize);


        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleNavClick = (path: string) => {
        setActivePath(path);
        localStorage.setItem('activePath', path);
        setIsSidebarOpen(false);
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };



    return (
        <div className='loader-container' style={{ display: "flex", height: "100vh" }}>

            <MessageModal message={modalMessage} icon={warningIcon} isOpen={modalMessageOpen} onClose={onClose} />

            <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`} style={{
                transform: isSidebarOpen ? 'translateX(0)' : 'translateX(-100%)',
                // transition: 'transform 0.3s ease-in-out',
                position: isSidebarOpen ? undefined : 'absolute'
            }}>
                <div style={{ display: "flex", margin: "20px", gap: "8px" }}>
                    <div className="icon-koop">
                        <img className="responsive-image" src={koopLogo} alt="Koop Logo" />
                    </div>
                    <div className="vertical-middle">
                        <div style={{ paddingLeft: "5px" }} className="font-green left-align font-bold width-100 font-size-17px ">
                            KOOP BATANGAN MPC
                        </div>
                        <div style={{ paddingLeft: "5px" }} className="font-green left-align width-100 ">
                            LOAN MANAGEMENT
                        </div>
                    </div>
                </div>
                <div className='navigator-container'>
                    <ul>

                        <li className={activePath === '/Members/MemberDetails' ? 'active' : ''}>
                            <Link to="/Members/MemberDetails" onClick={() => handleNavClick('/Members/MemberDetails')}>
                                <img src={iconProfileDetails} className="sidebar-icon" alt="Import" /> Account Details
                            </Link>
                        </li>
                        <li className={activePath === '/Members/BorrowerDetails' ? 'active' : ''}>
                            <Link to="/Members/BorrowerDetails" onClick={() => handleNavClick('/Members/BorrowerDetails')}>
                                <img src={iconLoan} className="sidebar-icon" alt="Import" /> Loan Details
                            </Link>
                        </li>
                        <li className={activePath === '/Members/CreateLoan' ? 'active' : ''}>
                            <Link
                                to="/Members/CreateLoan"
                                onClick={(e) => {
                                    if (username !== 'testMemember') {
                                        e.preventDefault();
                                        return;
                                    }
                                    handleNavClick('/Members/CreateLoan');
                                }}
                                style={username !== 'testMember' ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'none' } : undefined}
                            >
                                <img src={iconLoan} className="sidebar-icon" alt="Create Loan" /> Apply Loan
                            </Link>
                        </li>
                        <li className={activePath === '/Members/MemberChangePassword' ? 'active' : ''}>
                            <Link to="/Members/MemberChangePassword" onClick={() => handleNavClick('/Members/MemberChangePassword')}>
                                <img src={iconLock} className="sidebar-icon" alt="Import" /> Change Password
                            </Link>
                        </li>
                    </ul>
                    <a href="/Members/Login" className="logoutlink"><img src={iconLogout} className="sidebar-icon" alt="Logout" /> Logout</a>
                </div>
                <div className="copyright-font bottom-page font-green" style={{ width: "100%" }} >
                    2026 © DVIA Solutions
                    <span>Version 1.0.0</span>
                </div>
            </div>
            <div className="container main-container" style={{ width: isSidebarOpen ? '100%' : '100vw' }}>
                <div className="top-navbar font-size-17px" style={{ height: "50px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: '20px' }}>
                        <button
                            className="menu-button"
                            onClick={toggleSidebar}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            <img src={iconMenu} alt="Menu" className="sidebar-icon" />
                        </button>
                        <div className="dropdown" style={{ position: 'relative', display: 'inline-block' }}>
                            <button
                                className="dropdown-toggle"
                                style={{
                                    background: "none",
                                    border: "none",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    padding: "8px 16px"
                                }}
                                onClick={(e) => {
                                    const menu = e.currentTarget.nextElementSibling;
                                    if (menu) {
                                        menu.classList.toggle('show');
                                    }
                                }}
                            >
                                <img src={iconUsername} className="sidebar-icon" alt="User" /> &nbsp; {logUser}
                            </button>
                            <div className="dropdown-menu" style={{
                                position: 'absolute',
                                top: '100%',
                                right: 0,
                                backgroundColor: '#fff',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                display: 'none',
                                zIndex: 1000
                            }}>
                                <a href="/Members/Login" className="dropdown-item" style={{
                                    display: 'block',
                                    padding: '8px 16px',
                                    textDecoration: 'none',
                                    color: '#333'
                                }}>Logout</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MembersPortalLayout;